<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_account_settlement"
        :columns="columns"
        :mod-count="modCount"
        :raw-data="mockData"
        :show-del="false"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="true"
        :add-text="上传合同"
      />
    </div>
  </div>
</template>

<script>
import { getLinkTextStyle } from '@/utils/util'
import TableWrapper from '@/components/table-wrapper'
export default {
  name: 'AccountSettlementList',
  components: { TableWrapper },
  data() {
    return {
      url: this.$config.apiContextPath + '/account/settlement',
      modalForm: false,
      entityId: 0,
      modCount: 0
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '提现日期', width: '190px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择提现日期...', type: 'dateranger' },
          { label: '状态', placeholder: '请选择状态...', name: 'type', width: '100px', type: 'select', options: [
            { label: '已到账', value: 1 },
            { label: '待处理', value: 0 }
          ] }
        ]
      }
    },
    mockData() {
      return [
        {
          amount: 3000, // 提现金额
          actualAmount: 2400, // 实际到账金额
          cashBackAmount: 500, // 退款返现金额
          commissionAmount: 5, // 手续费金额
          status: 1, // 0 -> 待处理, 1 -> 已处理并到账
          applyTime: '2020-04-05 22:24', // 提现时间
          settleTime: '2020-04-25 23:01', // 到账时间,
          operator: '李四'
        },
        { amount: 2000, actualAmount: 0, cashBackAmount: 0, commissionAmount: 0, status: 0, applyTime: '2020-04-05 22:24', settleTime: '', operator: '李四' }
      ]
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index', disabled: true },
        { title: '提现金额', align: 'center', key: 'amount', sortable: true, ellipsis: true, tooltip: true },
        { title: '手续费', align: 'center', key: 'commissionAmount', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.status === 1 ? params.row.commissionAmount : '---')
          }
        },
        { title: '退款返现', align: 'center', key: 'cashBackAmount', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.status === 1 ? params.row.cashBackAmount : '---')
          }
        },
        { title: '实际到账', align: 'center', key: 'actualAmount', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.status === 1 ? params.row.actualAmount : '---')
          }
        },
        { title: '申请时间', align: 'center', sortable: true, key: 'applyTime', ellipsis: true, tooltip: true },
        { title: '到账时间', align: 'center', sortable: true, key: 'settleTime', ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.status === 1 ? params.row.settleTime : '---')
          }
        },
        { title: '状态', align: 'center', key: 'status', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.status === 1 ? '#28a745' : '#dc3545' }
            }, params.row.status === 1 ? '已到账' : '待处理')
          }
        },
        { title: '申请人', align: 'center', sortable: true, key: 'operator', ellipsis: true, tooltip: true },
        { title: '操作', align: 'center', width: 140, key: '_actions', disabled: true,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: getLinkTextStyle(params.row.status !== 1),
                on: {
                  click: () => {
                    if (params.row.id && params.row.status !== 1) {
                      // this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '撤销申请')
              ])
            ])
          }
        }
      ]
    }
  }
}
</script>
